module.exports = __webpack_public_path__ + "static/media/notes_icon2.391597a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notes/notes_icon2.svg
// module id = 1039
// module chunks = 0